import NumberAbbreviate from 'number-abbreviate'

import max from 'ramda/src/max'
import identity from 'ramda/src/identity'

import moment from '../moment'

const numAbbr = new NumberAbbreviate(['K', 'M', 'B', 'T'])

/**
 * rename `obj` keys with `mapper` object
 * @type {<T>(mapper: Object<string, string>) => (obj: T) => T}
 */
export const renameKeys = mapper => obj =>
  Object.keys(obj).reduce((acc, key) => {
    acc[mapper[key] || key] = obj[key]
    return acc
  }, {})

/**
 * `"2,000,000.25%"` -> `2000000.25`
 * @type {(n: string) => number}
 */
export const parseFinancial = n => parseFloat(String(n).replace(/,/g, ''))

/**
 * `2000000.25` -> `2,000,000.25`
 * @param {number} n
 */
export const financialFormatter = n =>
  n.toLocaleString('en', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

/**
 * Date and time formatter powered by MomentJS
 * @type {(format: string) => (d: string) => string}
 */
export const momentFormatter = format => d => (d ? moment(d).format(format) : '-')

/**
 * `"asc"` <-> `"desc"`
 * @param {'asc' | 'desc'} order
 */
export const toggleOrder = order => {
  if (order === 'asc') return 'desc'
  if (order === 'desc') return 'asc'
  return order
}

/**
 * `1000` -> `'1K'`, `250000` -> `'250K'`, ...
 * @param {number} value
 * @returns {string}
 */
export const abbreviateNumber = value => numAbbr.abbreviate(value, 1)

/**
 * finding the maximum number of `xs` array
 * @param {number[]} xs
 */
export const maximum = xs => xs.reduce(max, -Infinity)

/**
 * check whether a DOM element is visible
 * @param {HTMLElement} elem
 */
export const elementVisible = elem =>
  !!((elem.offsetWidth || elem.offsetHeight) && elem.offsetParent)

/**
 * check whether two dom elements are overlaping each other
 * @param {HTMLElement} elem1
 * @param {HTMLElement} elem2
 */
export const elementOverlap = (elem1, elem2) => {
  const [rect1, rect2] = [elem1.getBoundingClientRect(), elem2.getBoundingClientRect()]
  return (
    [elem1, elem2].every(elementVisible) &&
    ![
      rect1.right < rect2.left,
      rect1.left > rect2.right,
      rect1.bottom < rect2.top,
      rect1.top > rect2.bottom,
    ].some(identity)
  )
}

/**
 * string truncation
 * @param {number} chars number of limit characters
 * @param {string} s target string
 */
export const truncate = (chars, s) => (s.length >= chars ? `${s.slice(0, chars)}...` : s)

/**
 * finding percentages of `x` from `n`
 * @param {number} x
 * @param {number} n
 */
export const percentage = (x, n) => (x / n) * 100

/**
 * checking whether if `x` and `y` having the same mathematical sign
 * @param {number} x
 * @param {number} y
 */
export const isSameSign = (x, y) => Math.sign(x) === Math.sign(y)



// WEBPACK FOOTER //
// ./src/lib/utils/index.js